'use client'

import { ClaimsPermissionsModule } from '@repo/claims-tables/ClaimsPermissionsModule'

type ExpensesOvertimePermissionsProps = {
  isExpenses: boolean
}

export const ExpensesOvertimePermissions = ({ isExpenses }: ExpensesOvertimePermissionsProps) => {
  return (
    <>
      <ClaimsPermissionsModule isExpenses={isExpenses} />
    </>
  )
}
